import { Box, Button, Card, Typography } from "@mui/material";
import { useRef, useState } from "react";

export default function SidebarDetails({
  title = "Скрипт",
  id,
  price,
  productName,
  onConfirm,
  onOpenModal,
  imageComponent,
  actionComponent,
  faqData = [],
  bannerActions,
  type = "",
}) {
  const modalRef = useRef(null);
  const [modalType, setModalType] = useState(null);

  const handleOpenModal = (type) => {
    console.log("Open modal:", type);
    setModalType(type);
    onOpenModal?.(type);
  };

  const handleCloseModal = () => setModalType(null);
  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "5px",
          mb: 3,
          p: 2,
        }}
        className="bg-f6f7f9"
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            fontSize: 16,
            fontWeight: 500,
          }}
        >
          <Typography variant="h6">{title}</Typography>
          ID: {id}
        </Box>

        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {bannerActions}
        </Box>
      </Box>

      {/* Product Card */}
      <Card sx={{ display: "flex", gap: 3, alignItems: "start", mb: 3, p: 3 }}>
        <Card
          sx={{
            width: 300,
            height: 220,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 1,
          }}
        >
          {imageComponent}
        </Card>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box sx={{ flex: 1, maxWidth: "426px" }}>
            <Typography variant="h6" sx={{ fontWeight: 500, mt: 2 }}>
              {productName}
            </Typography>

            {actionComponent ? (
              <Box sx={{ mt: 1 }}>{actionComponent}</Box>
            ) : (
              // Default buttons if no `actionComponent` is passed
              <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
                <Button
                  variant="outlined"
                  onClick={() => handleOpenModal("attribute")}
                >
                  Додати атрибут
                </Button>
                <Button
                  variant="text"
                  onClick={() => handleOpenModal("quantity")}
                >
                  + Кількість
                </Button>
              </Box>
            )}
          </Box>

          <Typography variant="h6" sx={{ fontSize: 20, fontWeight: 600 }}>
            {price} ₴
          </Typography>
        </Box>
      </Card>
    </Box>
  );
}
